import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import './simple-button.scss';
import Color from '../Color';
import Icon from '../../../icons/index';
function SimpleButton({ title, onClick, color, isFetching, disabled, icon }) {
    const getColorClass = () => {
        switch (color) {
            case Color.YELLOW:
                return 'simple-button--yellow';
            case Color.BLACK:
                return 'simple-button--black';
            case Color.RED:
                return 'simple-button--red';
            default:
                return '';
        }
    };
    const buttoncContent = (_jsxs("span", { className: "simple-button__content", children: [icon ? _jsx(Icon, { name: icon }) : null, title] }));
    return (_jsx("button", { className: `simple-button ${getColorClass()}`, disabled: disabled, onClick: onClick, children: isFetching ? _jsx(BeatLoader, {}) : buttoncContent }));
}
SimpleButton.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    isFetching: PropTypes.bool,
    icon: PropTypes.string,
};
SimpleButton.defaultProps = {
    color: Color.YELLOW,
    disabled: false,
    isFetching: false,
    icon: '',
};
export default SimpleButton;
